module.exports = __webpack_public_path__ + "07a9274fd7f130a814866761609db9d1.MP3";